import { createStyles, makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) =>
  createStyles({
    payBtnWrapper: {
      '& div': {
        width: "100%",
        height: '54px',

        [theme.breakpoints.up('md')]: {
          height: '44px',
        },
      },
      '& button': {
        width: "100%",
        borderRadius: 4,
      }
    }
  })
);
